import * as React from 'react';
import { IFirstDayOfWeek } from '../types';
import { Typography } from '../../../atoms';
import { dayNames } from '../utils';
import { useHeaderStyles } from './Month.styles';

export interface IMonthProps {
  firstDayInWeek: IFirstDayOfWeek;
  locale?: string;
}

const MonthHeader: React.FC<IMonthProps> = ({ firstDayInWeek, locale }) => {
  const classes = useHeaderStyles();

  const names = dayNames(firstDayInWeek, locale);
  return (
    <>
      {names.map((day) => (
        <Typography
          as={'span'}
          variant={'body01'}
          key={day}
          className={classes.day}
        >
          {day}
        </Typography>
      ))}
    </>
  );
};

export default React.memo(MonthHeader);
